"use client";
import { apiCallsModalStore } from "./modalStore";
import { ApiCallModalType, FinmonErrorModalData } from "./types";

import { ApiCallsTypes, leadActionNameMap } from "./contants";
import { ProcessInstanceType } from "@/src/shared/schemas";
import {
  openAutocivilTarifChangeModal,
  openContractExistModal,
  openLimitZKModal,
  openTourizmTarifChangeModal,
} from "./Modals/modalsHandlers";
import { premiumStore } from "@/src/stores/premiumStore";
import { useProcessInstanceStore } from "@/src/stores/useProcessInstanceStore";
import { AnalyticsComponents } from "@/src/shared/models/analytics";
import { safeParseJson } from "@/src/shared/utils/form";
import { useTextUsModalStore } from "@/src/stores/useTextUsModalStore";

export const STOP_CALLS_ERROR = "STOP_CALLS_ERROR";

export const throwStopCallsError = () => {
  throw new Error(STOP_CALLS_ERROR);
};

export const isStopCallsError = (error: any) => {
  return error.message === STOP_CALLS_ERROR;
};

export const apiCallsSideEffects: Record<
  string,
  {
    onSuccess?: (
      data: any,
      responseData: any,
      callAnalytics?: (componentId: AnalyticsComponents) => void,
    ) => void;
    onError?: (data: any, currentFormData: any, error: any) => void;
  }
> = {
  [ApiCallsTypes.SEARCH_MTSBUMVS]: {
    onSuccess: (
      data: { submitStepId?: string; cancelStepId?: string },
      responseData: ProcessInstanceType,
    ) => {
      // TODO refactor
      const modalProps = {
        submitStepId: data.submitStepId,
        cancelStepId: data.cancelStepId,
        plateNumber: responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "plateNumber",
        )?.value as string,
        model: responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "model",
        )?.value as string,
        brand: responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "brand",
        )?.value as string,
      };

      apiCallsModalStore
        .getState()
        .open(ApiCallModalType.AUTO_SEARCH_SUCCESS, modalProps);
    },
    onError: (data: { stepId: string }, currentFormData: any) => {
      apiCallsModalStore.getState().open(ApiCallModalType.AUTO_SEARCH_ERROR, {
        stepId: data.stepId,
        plateNumber: currentFormData.plateNumber,
      });
    },
  },
  [ApiCallsTypes.CHECK_ORDLO]: {
    onError: (data: FinmonErrorModalData) => {
      apiCallsModalStore.getState().open(ApiCallModalType.FINMON_ERROR, data);
    },
  },
  [ApiCallsTypes.CHECK_RISK]: {
    onSuccess: (_: any, responseData) => {
      const riskCount =
        (responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "riskCount",
        )?.value as string) || 0;
      const isRisked = Number(riskCount) > 0;

      if (isRisked) {
        openAutocivilTarifChangeModal({
          onCancel: () => {
            window.open("https://www.pzu.com.ua/useful/filials.html", "_blank");
            apiCallsModalStore.getState().close();
          },
          onSubmit: async ({ nextStep }) => {
            await nextStep();
            apiCallsModalStore.getState().close();
          },
        });
        throwStopCallsError();
      }
    },
  },
  [ApiCallsTypes.PICK_TRAVEL_TARIFF_CATEGORY_ACTION]: {
    onSuccess: (_: any, responseData: ProcessInstanceType, callAnalytics) => {
      const premium = premiumStore.getState().premium;
      const finalPremium =
        (responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "finalPremium",
        )?.value as string) || 0;

      const flowCode =
        (responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "flowCode",
        )?.value as string) || "";
      const processInstanceStatus =
        useProcessInstanceStore.getState().processInstance.order.status;

      if (Number(finalPremium) > 40000 && flowCode !== "VZK_NEW") {
        callAnalytics && callAnalytics(AnalyticsComponents.ZK_MAX_LIMIT);
        openLimitZKModal({
          onCancel: () => {
            window.open("https://www.pzu.com.ua/useful/filials.html", "_blank");
            apiCallsModalStore.getState().close();
          },
          onSubmit: () => {
            apiCallsModalStore.getState().close();
            useTextUsModalStore.getState().open();
          },
        });
        throwStopCallsError();
        return;
      }

      if (
        processInstanceStatus !== "CALCULATION" &&
        Number(finalPremium) > 0 &&
        premium > 0 &&
        Number(finalPremium) !== premium
      ) {
        openTourizmTarifChangeModal({
          onCancel: () => {
            apiCallsModalStore.getState().close();
          },
          onSubmit: async ({ nextStep }) => {
            if (Number(finalPremium) > 40000) {
              callAnalytics && callAnalytics(AnalyticsComponents.ZK_MAX_LIMIT);
              openLimitZKModal({
                onCancel: () => {
                  window.open(
                    "https://www.pzu.com.ua/useful/filials.html",
                    "_blank",
                  );
                  apiCallsModalStore.getState().close();
                },
                onSubmit: () => {
                  apiCallsModalStore.getState().close();
                  useTextUsModalStore.getState().open();
                },
              });
              return;
            }
            await nextStep();
            apiCallsModalStore.getState().close();
          },
        });
        throwStopCallsError();
      }
    },
  },
  [ApiCallsTypes.PERFORM_FINAP_ACTION]: {
    onSuccess: (_: any, responseData: ProcessInstanceType, callAnalytics) => {
      const finalPremium =
        (responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "finalPremium",
        )?.value as string) || 0;

      const flowCode =
        (responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "flowCode",
        )?.value as string) || "";

      if (Number(finalPremium) > 40000 && flowCode !== "VZK_NEW") {
        callAnalytics && callAnalytics(AnalyticsComponents.ZK_MAX_LIMIT);
        openLimitZKModal({
          onCancel: () => {
            window.open("https://www.pzu.com.ua/useful/filials.html", "_blank");
            apiCallsModalStore.getState().close();
          },
          onSubmit: () => {
            apiCallsModalStore.getState().close();
            useTextUsModalStore.getState().open();
          },
        });
        throwStopCallsError();
      }
    },
    onError: (data: FinmonErrorModalData, _, error: Error) => {
      if (isStopCallsError(error)) {
        return;
      }
      apiCallsModalStore
        .getState()
        .open(ApiCallModalType.FINMON_ERROR, { ...data, error });
    },
  },
  [ApiCallsTypes.CHECK_CONTRACTS]: {
    onSuccess: (_: any, responseData: ProcessInstanceType) => {
      // const contractNumber = useContextStore.getState().getVariable("checkContractNumber");
      const contractNumber = responseData.contextInstance.variables.find(
        (variable: any) => variable.key === "checkContractNumber",
      )?.value as string;
      const flowCode =
        (responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "flowCode",
        )?.value as string) || 0;
      const period = responseData.contextInstance.variables.find(
        (variable: any) => variable.key === "datePeriod",
      )?.value as string;
      const isModalShouldBeOpened =
        flowCode === "VOSCPVVNTZ" ? period?.includes("12Months") : true;
      if (contractNumber && isModalShouldBeOpened) {
        openContractExistModal({
          onCancel: () => {
            apiCallsModalStore.getState().close();
            window.open("https://www.pzu.com.ua/useful/filials.html", "_blank");
          },
          onSubmit: () => {
            apiCallsModalStore.getState().close();
          },
        });
      }
    },
  },
  [ApiCallsTypes.VALIDATE_PROMOCODE]: {
    onSuccess: (_: any, responseData: ProcessInstanceType) => {
      const premium = premiumStore.getState().premium;
      const finalPremium =
        (responseData.contextInstance.variables.find(
          (variable: any) => variable.key === "finalPremium",
        )?.value as string) || 0;
      const processInstanceStatus =
        useProcessInstanceStore.getState().processInstance.order.status;
      const stepCode =
        useProcessInstanceStore.getState().processInstance.activeStep?.code;

      const getLeadAction = () => {
        const flowCode =
          (responseData.contextInstance.variables.find(
            (variable: any) => variable.key === "flowCode",
          )?.value as string) || "";
        return flowCode && leadActionNameMap[flowCode];
      };
      if (
        !stepCode?.includes("offers") &&
        processInstanceStatus !== "CALCULATION" &&
        processInstanceStatus !== "CHECK_AND_SIGN" &&
        Number(finalPremium) > 0 &&
        premium > 0 &&
        Number(finalPremium) !== premium
      ) {
        openTourizmTarifChangeModal({
          onCancel: () => {
            apiCallsModalStore.getState().close();
          },
          onSubmit: async ({ nextStep, handleApiCallByName }) => {
            const needPVI = safeParseJson(
              (responseData.contextInstance.variables.find(
                (variable: any) => variable.key === "needPVI",
              )?.value as string) || false,
            );
            if (!needPVI) {
              const leadActionName = getLeadAction();
              leadActionName &&
                (await handleApiCallByName(leadActionName, true));
              await nextStep();
            }
            apiCallsModalStore.getState().close();
          },
        });
        throwStopCallsError();
      }
    },
  },
  [ApiCallsTypes.CHECK_BLACK_LIST]: {
    onError: (_, __, error: Error) => {
      if (isStopCallsError(error)) {
        return;
      }
      apiCallsModalStore
        .getState()
        .open(ApiCallModalType.FINMON_ERROR, { error });
    },
  },
  // ["approve"]: {
  //   onSuccess: (data: { stepId: string }, responseData: AutoSearchResponse) => {
  //     const modalProps = {
  //       stepId: data.stepId,
  //       plateNumber: responseData.List.item.plateNumber,
  //       model: responseData.List.item.vehicleModel.name,
  //     };
  //     apiCallsModalStore.getState().open(ApiCallModalType.SUCCESS, modalProps);
  //     useOrderAgreementModalStore
  //       .getState()
  //       .setStage(OrderAgreementStages.Sign);
  //   },
  //   onError: (data: { stepId: string }, currentFormData: any) => {
  //     console.log("currentFormData", currentFormData);
  //     apiCallsModalStore.getState().open(ApiCallModalType.ERROR, {
  //       stepId: data.stepId,
  //       plateNumber: currentFormData.plateNumber,
  //     });
  //   },
  // },
};
